import { useState, useEffect } from "react";
import "../components/content_overlay.css";

function ContentOverlay({ heading, text_content }) {
  const [title, setTitle] = useState();
  const [content, setContent] = useState();

  useEffect(() => {
    if (heading) setTitle(heading);
    if (text_content) setContent(text_content);
  }, [heading, text_content]);

  return (
    <div id="background_image_for_content"
    >
      <div id="content-overlay"
   >
        <h2>{title}</h2>
        <p style={{ fontSize: "0.99999em", fontFamily: "revert" }}>{content}</p>
      </div>
    </div>
  );
}

export default ContentOverlay;
